import { Routes, Route, useLocation, Navigate } from 'react-router-dom'
import { jwtDecode } from 'jwt-decode'

import LandingPage from './components/LandingPage/LandingPageMain'
import Policy from './components/Policy/Policy'
import Terms from './components/Terms/Terms'
import Login from './components/Auth/Login'
import Register from './components/Auth/Register'
import ForgotPassword from './components/Auth/ForgotPassword'
import ResetPassword from './components/Auth/ResetPassword'
import VerifyEmail from './components/Auth/VerifyEmail'
import ExtensionAuth from './components/ExtensionAuth/ExtensionAuth'
import Settings from './components/Settings/Settings'
import Analytics from './components/Analytics/Analytics'
import SuccessMessageHandler from './components/EmailAccessModal/EmailSuccessMessageHandler'
import Tutorial from './components/Tutorial/Index'
import Feedback from './components/Feedback'
import EmailAnalytics from './components/EmailAnalytics/EmailAnalytics'
import Loadboard from './components/Loadboard/Loadboard'
import Research from './components/Research/Research'
import Admin from './components/Admin/Admin'
import AdminGate from './components/Admin/AdminGate'
import { MeProvider } from './context/MeContext'
import { ExtensionStatusProvider } from './context/ExtensionStatusContext'

function AppRouter() {
	const location = useLocation()

	const jwtToken = localStorage.getItem('jwtToken')
	const user = jwtToken

	try {
		if (jwtToken) jwtDecode(jwtToken)
	} catch {
		localStorage.removeItem('jwtToken')
	}

	const isFromExtension =
		new URLSearchParams(location.search).get('from') === 'extension'

	if (user) {
		if (isFromExtension) {
			return (
				<Routes>
					<Route path="/extension" element={<ExtensionAuth token={user} />} />
					<Route path="*" element={<Navigate to="/extension" replace />} />
				</Routes>
			)
		}

		return (
			<MeProvider>
				<ExtensionStatusProvider>
					<SuccessMessageHandler />
					<Routes>
						<Route path="/tutorial" element={<Tutorial />} />
						<Route path="/verify-email" element={<VerifyEmail />} />
						<Route path="/uninstall" element={<Feedback />} />
						<Route path="/extension" element={<ExtensionAuth token={user} />} />
						<Route path="/policy" element={<Policy />} />
						<Route path="/terms" element={<Terms />} />
						<Route path="/settings" element={<Settings />}>
							<Route
								index
								element={<Navigate to="/settings/email" replace />}
							/>
							<Route path=":tab" element={<Settings />} />
						</Route>
						<Route path="/analytics" element={<Analytics />} />
						<Route
							path="/research"
							element={
								<AdminGate>
									<Research />
								</AdminGate>
							}
						/>
						<Route path="/multiboard" element={<Loadboard />} />
						<Route path="/dashboard" element={<EmailAnalytics />} />
						<Route
							path="/admin/*"
							element={
								<AdminGate>
									<Admin />
								</AdminGate>
							}
						/>
						<Route path="*" element={<Navigate to="/dashboard" replace />} />
					</Routes>
				</ExtensionStatusProvider>
			</MeProvider>
		)
	}

	return (
		<Routes>
			<Route path="/" element={<LandingPage />} />
			<Route path="/uninstall" element={<Feedback />} />
			<Route path="/login" element={<Login />} />
			<Route path="/register" element={<Register />} />
			<Route path="/verify-email" element={<VerifyEmail />} />
			<Route path="/forgot-password" element={<ForgotPassword />} />
			<Route path="/reset-password/:token" element={<ResetPassword />} />
			<Route path="/policy" element={<Policy />} />
			<Route path="/terms" element={<Terms />} />
			<Route path="/extension" element={<ExtensionAuth />} />
			<Route path="*" element={<Navigate to="/" replace />} />
		</Routes>
	)
}

export default AppRouter
